import React,{useState} from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import { Container, Row, Col } from '../../../components/ui/wrapper'
import SectionTitle from '../../../components/ui/section-title'
// import Text from '../../../components/ui/text'
import Modal from 'react-bootstrap/Modal'
import Button from '../../../components/ui/button'
import { SectionWrap, JobList, JobItem, JobTitle, JobType, JobDesc, JobButton } from './style'
import ApplicationForm from '../../../components/forms/job-form'

const JobsArea = () => {
    // {textStyle}
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    // const [handleCloseModal, setHandleCloseModal] =useState(false)
    const handleShow = () => setShow(true);

    const getJobsData = useStaticQuery(graphql`
        query GET_JOBS_DATA {

            intro: careersJson(id: {eq: "careers-section-intro"}) {
                title
            }

            careersstatus: careersJson(id: {eq: "careers-status"}) {
                status
            }

            jobs: careersJson(id: {eq: "our-open-jobs"}) {
                jobs {
                    id
                    title
                    type
                    description
                    link
                }
            }
        }      
    `);
    
    const { intro: { title }, jobs: { jobs } } = getJobsData
return (
    <SectionWrap>
        <Container>
            <Row justify="center">
                <Col lg={7}>
                    <SectionTitle title={title} />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <JobList>
                        {jobs.map((job, i) => {
                            const isEven = i % 2 === 0;
                            return (
                                <JobItem key={job.id} isEven={isEven}>
                                    <Row>
                                        <Col lg={3}>
                                            <JobTitle>{job.title}</JobTitle>
                                            <JobType>{job.type}</JobType>
                                        </Col>
                                        <Col lg={6}>
                                            <JobDesc>
                                                {job.description}
                                                <br/> <small style={{color:"dodgerblue"}}>Posted on: 24/05/2021</small>
                                            </JobDesc>
                                            <Button to={job.link} target="_blank" varient="outlined" bordercolor="#ddd">View Details</Button>
                                        </Col>
                                        <Col lg={3}>
                                            <JobButton>
                                                <Button onClick={handleShow} varient="outlined" bordercolor="#ddd">Apply</Button>
                                            </JobButton>
                                        </Col>
                                    </Row>
                                </JobItem>
                            )
                        })}
                    </JobList>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose}  size="xl">
                <Modal.Header closeButton>
                <Modal.Title>Apply Online</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ApplicationForm/>
                </Modal.Body>
            </Modal>
        </Container>
    </SectionWrap>
)
}

export default JobsArea
